/**
 * SEO：外链判定
 * 规则：所有指向非 gyqxmall.com 及其子域的链接，需加 rel="nofollow"。
 * 由各组件显式调用 isExternalLink 判断后自行加 rel="nofollow"，
 * 不再做全站 HTML 自动改写。
 */
const SITE_HOST = 'gyqxmall.com';
/** 非跳转型协议 / 锚点，不视为外链 */
const NON_NAVIGATION_RE = /^(#|mailto:|tel:|sms:|javascript:|data:)/i;

/** 是否为外部链接：绝对地址且不在 gyqxmall.com 及其子域下 */
export function isExternalLink(url?: string | null): boolean {
	const value = String(url ?? '').trim();
	if (!value) return false;
	if (NON_NAVIGATION_RE.test(value)) return false;
	// 相对路径 / 协议相对路径均按站内处理
	if (!/^https?:\/\//i.test(value)) return false;

	try {
		const host = new URL(value).hostname.toLowerCase();
		return !(host === SITE_HOST || host.endsWith(`.${SITE_HOST}`));
	} catch {
		return false;
	}
}
